import type { IconAsset } from '../Icon.types';

export const twitterX: IconAsset = {
  regular: {
    l: {
      code: (
        <g>
          <path
            d='M11.3094 8.0461L18.3838 0H16.708L10.5627 6.98489L5.6582 0H0L7.41823 10.5634L0 18.9999H1.6758L8.16113 11.6221L13.3418 18.9999H19M2.28063 1.2365H4.85513L16.7067 17.8242H14.1316'
            fill='currentColor'
          />
        </g>
      ),
    },
    m: {
      code: (
        <g>
          <path
            d='M11.3094 8.0461L18.3838 0H16.708L10.5627 6.98489L5.6582 0H0L7.41823 10.5634L0 18.9999H1.6758L8.16113 11.6221L13.3418 18.9999H19M2.28063 1.2365H4.85513L16.7067 17.8242H14.1316'
            fill='currentColor'
          />
        </g>
      ),
    },
    s: {
      code: (
        <g>
          <path
            d='M11.3094 8.0461L18.3838 0H16.708L10.5627 6.98489L5.6582 0H0L7.41823 10.5634L0 18.9999H1.6758L8.16113 11.6221L13.3418 18.9999H19M2.28063 1.2365H4.85513L16.7067 17.8242H14.1316'
            fill='currentColor'
          />
        </g>
      ),
    },
  },
};
